import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=1a5cd833&scoped=true"
import script from "./sort.vue?vue&type=script&lang=ts"
export * from "./sort.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5cd833",
  null
  
)

export default component.exports